/**
 * api.js — Axios client for the CPG AI Lab backend.
 *
 * Emergent convention: the backend is reachable at `${process.env.REACT_APP_BACKEND_URL}/api`.
 * If your app already exports a shared axios instance (e.g. `@/lib/axios`), swap `http` for it.
 * Auth: we assume an interceptor elsewhere attaches the bearer token; if not, uncomment the block below.
 */
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const http = axios.create({ baseURL: BASE_URL, withCredentials: true });

// http.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// ── Brand Profile ────────────────────────────────────────────────────────────
export const brandProfileApi = {
  get: () => http.get("/ai-lab/brand-profile").then((r) => r.data),
  save: (profile) => http.put("/ai-lab/brand-profile", profile).then((r) => r.data),
  remove: () => http.delete("/ai-lab/brand-profile").then((r) => r.data),
};

// ── Saved prompts ────────────────────────────────────────────────────────────
export const savedPromptsApi = {
  list: () => http.get("/ai-lab/saved-prompts").then((r) => r.data),
  create: (payload) => http.post("/ai-lab/saved-prompts", payload).then((r) => r.data),
  remove: (id) => http.delete(`/ai-lab/saved-prompts/${id}`).then((r) => r.data),
};

// ── Usage events (fire-and-forget analytics) ────────────────────────────────
export const eventsApi = {
  track: (event) => http.post("/ai-lab/events", event).catch(() => {}),
};

// ── Admin ────────────────────────────────────────────────────────────────────
export const adminApi = {
  stats: () => http.get("/ai-lab/admin/stats").then((r) => r.data),
};
